module.exports = __webpack_public_path__ + "static/media/fhl_3l.b01d4c34.png";